import Handler from "../Handler";

class TourneyRemoveHandler extends Handler {
  execute(message) {
    let receivedData = JSON.parse(message);
    this.service.processTourneyRemove(receivedData);
  }
}
export default TourneyRemoveHandler;
